import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.string.trim-right.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.string.anchor.js";
import "core-js/modules/es6.number.is-finite.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.regexp.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import L from 'leaflet';
import { each, findIndex, debounce } from 'lodash';

// #19pc — ricarica automatica dei cantieri quando l'utente si ferma di muovere
// la mappa. Google emette 'idle' solo a movimento finito (non durante il
// trascinamento): l'attesa qui sotto serve solo a coalizzare la raffica di
// 'idle' che arriva dai resize programmatici e dalle animazioni di zoom.
var MOVE_END_DEBOUNCE = 500;
// 'idle' arriva anche da movimenti NON dell'utente (triggerMapResize, prop
// mapZoom, ResizeObserver): il movimento vale come "dell'utente" solo se un
// suo gesto è arrivato entro questa finestra.
var USER_GESTURE_WINDOW = 2000;
// I gesti che contano come "sto muovendo la mappa". I bottoni di zoom non
// ci sono (mapOptions.zoomControl === false), quindi restano trascinamento,
// rotella, doppio click, pinch e tastiera.
var USER_GESTURE_EVENTS = ['mousedown', 'wheel', 'touchstart', 'touchmove', 'dblclick', 'keydown'];
// Badge di provincia: due righe (nome breve sopra, conteggio sotto), larghi quanto il testo più
// largo. pages/index.vue (HOME_MAP_PADDING_*) è costruito su questo ingombro nella posizione di
// base: larghi al massimo PROVINCE_BADGE_MAX_WIDTH, da 20 a 20 + PROVINCE_BADGE_HEIGHT px sotto la
// coordinata. Se cambiano questi numeri va aggiornato anche quello.
var PROVINCE_BADGE_MAX_WIDTH = 95;
var PROVINCE_BADGE_MIN_WIDTH = 60;
var PROVINCE_BADGE_HEIGHT = 40;
var PROVINCE_BADGE_TEXT_PADDING = 10;
var PROVINCE_BADGE_NAME_FONT_SIZE = 11;
var PROVINCE_BADGE_COUNT_FONT_SIZE = 10;
// Distanza minima fra due badge: sotto questa soglia contano come sovrapposti.
var PROVINCE_BADGE_GAP = 2;
// Posizioni provate per ogni badge, in ordine di preferenza: (dx, dy) è l'angolo in alto a
// sinistra del badge rispetto alla coordinata della provincia. La prima è quella di sempre, 20 px
// sotto la coordinata per non coprire il nome della città; le altre servono solo quando quella si
// scontra con un badge già messo.
var PROVINCE_BADGE_POSITIONS = [function (w, h) {
  return {
    dx: -w / 2,
    dy: 20
  };
}, function (w, h) {
  return {
    dx: -w / 2,
    dy: -8 - h
  };
}, function (w, h) {
  return {
    dx: 12,
    dy: -h / 2
  };
}, function (w, h) {
  return {
    dx: -12 - w,
    dy: -h / 2
  };
}, function (w, h) {
  return {
    dx: 12,
    dy: 20
  };
}, function (w, h) {
  return {
    dx: -12 - w,
    dy: 20
  };
}, function (w, h) {
  return {
    dx: 12,
    dy: -8 - h
  };
}, function (w, h) {
  return {
    dx: -12 - w,
    dy: -8 - h
  };
}, function (w, h) {
  return {
    dx: -w / 2,
    dy: 24 + h
  };
}];
var textMeasureContext = null;
// Larghezza del testo come la disegna il browser; senza canvas (render SSR) una stima, che vale
// solo finché il client non ricalcola le icone al montaggio della mappa.
var measureBadgeText = function measureBadgeText(text, fontSize) {
  if (typeof document !== 'undefined') {
    textMeasureContext = textMeasureContext || document.createElement('canvas').getContext('2d');
    if (textMeasureContext) {
      textMeasureContext.font = "bold ".concat(fontSize, "px Arial, sans-serif");
      return textMeasureContext.measureText(text).width;
    }
  }
  return text.length * fontSize * 0.6;
};
var overlapArea = function overlapArea(a, b) {
  var x = Math.min(a.right, b.right) - Math.max(a.left, b.left) + PROVINCE_BADGE_GAP;
  var y = Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top) + PROVINCE_BADGE_GAP;
  return x > 0 && y > 0 ? x * y : 0;
};
export default {
  props: {
    markers: {
      type: Array
    },
    showConstructionMarkers: {
      type: Boolean,
      default: true
    },
    provinceMarkers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bounds: {
      default: function _default() {
        return '';
      }
    },
    selectedMarker: {
      type: Object
    },
    center: {
      type: Object,
      default: function _default() {
        return {
          lat: 44.645647,
          lng: 10.923173
        };
      }
    },
    mapZoom: {
      default: function _default() {
        return 14;
      }
    }
  },
  data: function data() {
    return {
      hoverTimer: null,
      popupPinned: false,
      hoveredMarker: null,
      // #9pc — stato dello sfioro sui badge di provincia, tenuto separato da
      // hoverTimer/popupPinned/hoveredMarker qui sopra, che sono cablati sul
      // popup del singolo cantiere (isMarkerActive, selectMarker).
      provinceHoverTimer: null,
      hoveredProvince: null,
      apiKey: process.env.GOOGLE_API_KEY || 'AIzaSyAt-5tQM_uYRx7Q1cFGOMbtNx2fq7sdZz8',
      map: null,
      // center: L.latLng(44.645647, 10.923173),
      clusterOptions: {
        disableClusteringAtZoom: 16,
        spiderfyOnMaxZoom: false,
        iconCreateFunction: this.iconCreateFunction
      },
      popupOptions: {
        closeButton: true,
        minWidth: 300,
        autoPanPadding: L.point(window.innerWidth * 0.05, 50)
      },
      mapOptions: {
        zoomControl: false,
        layerControl: true,
        fullscreenControl: false,
        mapTypeControl: false,
        styles: [{
          featureType: 'poi',
          stylers: [{
            visibility: 'off'
          }]
        }, {
          featureType: 'transit',
          elementType: 'labels.icon',
          stylers: [{
            visibility: 'on'
          }]
        }]
      },
      clusterMarkers: [{
        width: 32,
        height: 32,
        url: '/statics/images/markers/marker-cluster.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-b.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-r.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-y.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-br.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-by.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-ry.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-bry.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-b-sm.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-r-sm.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-y-sm.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-br-sm.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-by-sm.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-ry-sm.png'
      }, {
        width: 40,
        height: 40,
        url: '/statics/images/markers/marker-cluster-bry-sm.png'
      }],
      googleMapsApi: null,
      provinceIconCache: {},
      // slug → indice in PROVINCE_BADGE_POSITIONS, calcolato da layoutProvinceBadges
      provincePlacements: {}
    };
  },
  watch: {
    center: function center(val) {
      if (!this.map) return;
      this.map.setCenter(val);
    },
    // A zoom change while the map is still settling after SSR hydration can
    // leave tiles/markers unpainted: re-trigger a resize shortly after.
    mapZoom: function mapZoom() {
      var _this = this;
      setTimeout(function () {
        return _this.triggerMapResize();
      }, 150);
    },
    // Same stalled-renderer issue on filter changes: the marker set updates in
    // the store but the map doesn't repaint, leaving stale markers visible.
    markers: function markers() {
      var _this2 = this;
      setTimeout(function () {
        return _this2.triggerMapResize();
      }, 150);
    },
    provinceMarkers: {
      deep: true,
      handler: function handler() {
        var _this3 = this;
        this.provinceIconCache = {};
        this.$nextTick(function () {
          return _this3.layoutProvinceBadges();
        });
      }
    }
  },
  methods: {
    triggerMapResize: function triggerMapResize() {
      if (!this.map || typeof window === 'undefined' || !window.google || !window.google.maps) return;
      var center = this.map.getCenter();
      window.google.maps.event.trigger(this.map, 'resize');
      if (center) {
        this.map.setCenter(center);
      }
    },
    isMarkerActive: function isMarkerActive(m) {
      var active = this.hoveredMarker || this.selectedMarker;
      return active && m.id === active.id;
    },
    // NOTE: OLDWARE Leaflet
    initMap: function initMap() {
      this.map = this.$refs.myMap.mapObject;
      this.map.locate({
        setView: true,
        maxZoom: 12
      });
    },
    getMarkerIcon: function getMarkerIcon(construction) {
      var iconName = 'marker-single-';
      if (construction.commercial) {
        iconName += 'b';
      }
      if (construction.terrain) {
        iconName += 'r';
      }
      if (construction.residential) {
        iconName += 'y';
      }
      if (construction.status === 'in_history') {
        iconName = 'marker-single-bla';
      }
      if (this.isMarkerActive(construction)) {
        iconName += '-active';
      }
      return '/statics/images/markers/' + iconName + '.png';
    },
    markerIconCalculator: function markerIconCalculator(markers, numStyles) {
      var iconName = 'marker-cluster-';
      var residential = false;
      var commercial = false;
      var terrain = false;
      each(markers, function (marker) {
        residential |= marker.construction.residential;
        commercial |= marker.construction.commercial;
        terrain |= marker.construction.terrain;
      });
      if (commercial) {
        iconName += 'b';
      }
      if (terrain) {
        iconName += 'r';
      }
      if (residential) {
        iconName += 'y';
      }

      // if (markers.getChildCount() < 5) {
      //   iconName += '-sm'
      // }
      return {
        text: '',
        index: findIndex(this.clusterMarkers, {
          url: '/statics/images/markers/' + iconName + '.png'
        }) + 1
      };
    },
    iconCreateFunction: function iconCreateFunction(cluster) {
      var iconName = 'marker-cluster-';
      var markers = cluster.getAllChildMarkers();
      var residential = false;
      var commercial = false;
      var terrain = false;
      each(markers, function (marker) {
        residential |= marker.options.construction.residential;
        commercial |= marker.options.construction.commercial;
        terrain |= marker.options.construction.terrain;
      });
      if (commercial) {
        iconName += 'b';
      }
      if (terrain) {
        iconName += 'r';
      }
      if (residential) {
        iconName += 'y';
      }
      if (cluster.getChildCount() < 5) {
        iconName += '-sm';
      }
      return L.icon({
        iconUrl: '/statics/images/markers/' + iconName + '.png'
      });
    },
    updateBounds: function updateBounds() {
      if (this.map) {
        // debugger
        this.$emit('update:bounds', JSON.stringify({
          type: 'Polygon',
          coordinates: [[[this.map.getBounds().getSouthWest().lng(), this.map.getBounds().getNorthEast().lat()], [this.map.getBounds().getNorthEast().lng(), this.map.getBounds().getNorthEast().lat()], [this.map.getBounds().getNorthEast().lng(), this.map.getBounds().getSouthWest().lat()], [this.map.getBounds().getSouthWest().lng(), this.map.getBounds().getSouthWest().lat()], [this.map.getBounds().getSouthWest().lng(), this.map.getBounds().getNorthEast().lat()]]],
          center: "".concat(this.map.getCenter().lng(), ", ").concat(this.map.getCenter().lat())
        }));
      }
    },
    // #19pc — traccia l'ultimo gesto dell'utente sulla mappa. Serve solo a
    // distinguere un movimento vero da uno programmatico: vedi notifyMoveEnd.
    markUserGesture: function markUserGesture() {
      this.lastUserGestureAt = Date.now();
    },
    // #19pc — il movimento dell'utente è finito: allinea subito i bounds
    // (l'emissione su 'bounds_changed' è debounced di 300 ms) e avvisa il
    // padre, che decide se ricaricare.
    notifyMoveEnd: function notifyMoveEnd() {
      if (!this.map) return;
      if (Date.now() - this.lastUserGestureAt > USER_GESTURE_WINDOW) return;
      this.updateBounds();
      this.$emit('user-move-end');
    },
    closeInfoWindows: function closeInfoWindows() {
      this.popupPinned = false;
      this.$refs.infoWindow.forEach(function (iw) {
        if (iw.opened) {
          iw.opened = false;
        }
      });
      this.selectMarker(null);
    },
    selectMarker: function selectMarker(m) {
      this.hoveredMarker = null;
      if (!m) {
        this.popupPinned = false;
      }
      if (this.$q.screen.gt.xs && m) {
        m.showInfo = true;
      }
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
      }
      this.$emit('update:selectedMarker', m);
    },
    hoverMarker: function hoverMarker(m) {
      if (this.$q.screen.gt.xs && m) {
        m.showInfo = true;
      }
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
      }
      this.hoveredMarker = m;
    },
    onMarkerMouseover: function onMarkerMouseover(m) {
      if (this.popupPinned) return;
      this.hoverMarker(m);
    },
    onMarkerMouseout: function onMarkerMouseout() {
      var _this4 = this;
      if (this.popupPinned) return;
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
      this.hoverTimer = setTimeout(function () {
        _this4.hoverMarker(null);
      }, 400);
    },
    onMarkerClick: function onMarkerClick(m) {
      this.popupPinned = true;
      this.selectMarker(m);
    },
    onInfoWindowReady: function onInfoWindowReady(index) {
      var _this5 = this;
      var iwRef = this.$refs.infoWindow[index];
      if (!iwRef) return;
      iwRef.$infoWindowPromise.then(function (infoWindow) {
        var content = infoWindow.getContent();
        if (!content || content.dataset.hoverListeners) return;
        content.dataset.hoverListeners = 'true';
        content.addEventListener('mouseenter', function () {
          if (_this5.hoverTimer) {
            clearTimeout(_this5.hoverTimer);
            _this5.hoverTimer = null;
          }
        });
        content.addEventListener('mouseleave', function () {
          if (_this5.popupPinned) return;
          _this5.hoverTimer = setTimeout(function () {
            _this5.hoverMarker(null);
          }, 400);
        });
      });
    },
    onProvinceClick: function onProvinceClick(province) {
      this.$emit('province-click', province);
    },
    isProvinceActive: function isProvinceActive(province) {
      return !!province && !!this.hoveredProvince && this.hoveredProvince.slug === province.slug;
    },
    hoverProvince: function hoverProvince(province) {
      if (this.provinceHoverTimer) {
        clearTimeout(this.provinceHoverTimer);
        this.provinceHoverTimer = null;
      }
      // stesso gate desktop usato dal popup cantiere (:22 nel template e
      // hoverMarker qui sopra): larghezza schermo, non mixin isMobile.
      this.hoveredProvince = this.$q.screen.gt.xs ? province : null;
    },
    onProvinceMouseover: function onProvinceMouseover(province) {
      this.hoverProvince(province);
    },
    onProvinceMouseout: function onProvinceMouseout() {
      var _this6 = this;
      if (this.provinceHoverTimer) {
        clearTimeout(this.provinceHoverTimer);
      }
      this.provinceHoverTimer = setTimeout(function () {
        _this6.hoverProvince(null);
      }, 400);
    },
    // Come onInfoWindowReady per i cantieri: senza questi due listener il
    // fumetto si chiuderebbe appena il mouse lascia il badge per entrarci
    // dentro, rendendo "apri lista" incliccabile.
    onProvinceInfoWindowReady: function onProvinceInfoWindowReady(index) {
      var _this7 = this;
      var refs = this.$refs.provinceInfoWindow;
      var iwRef = Array.isArray(refs) ? refs[index] : refs;
      if (!iwRef) return;
      iwRef.$infoWindowPromise.then(function (infoWindow) {
        var content = infoWindow.getContent();
        if (!content || content.dataset.provinceHoverListeners) return;
        content.dataset.provinceHoverListeners = 'true';
        content.addEventListener('mouseenter', function () {
          if (_this7.provinceHoverTimer) {
            clearTimeout(_this7.provinceHoverTimer);
            _this7.provinceHoverTimer = null;
          }
        });
        content.addEventListener('mouseleave', function () {
          _this7.provinceHoverTimer = setTimeout(function () {
            _this7.hoverProvince(null);
          }, 400);
        });
      });
    },
    // Testi e misura del badge. Il nome usa la forma breve passata dalla pagina (shortName, per
    // esempio «Reggio E.»); se non sta comunque nella larghezza massima viene troncato con «…».
    getProvinceBadge: function getProvinceBadge(province) {
      var maxTextWidth = PROVINCE_BADGE_MAX_WIDTH - 2 * PROVINCE_BADGE_TEXT_PADDING;
      var countLabel = (province.countLabel || '').trim() || '0';
      var name = (province.shortName || province.name || '').trim();
      if (measureBadgeText(name, PROVINCE_BADGE_NAME_FONT_SIZE) > maxTextWidth) {
        while (name.length > 1 && measureBadgeText("".concat(name, "\u2026"), PROVINCE_BADGE_NAME_FONT_SIZE) > maxTextWidth) {
          name = name.slice(0, -1).trimEnd();
        }
        name = "".concat(name, "\u2026");
      }
      var textWidth = Math.max(measureBadgeText(name, PROVINCE_BADGE_NAME_FONT_SIZE), measureBadgeText(countLabel, PROVINCE_BADGE_COUNT_FONT_SIZE));
      var width = Math.min(PROVINCE_BADGE_MAX_WIDTH, Math.max(PROVINCE_BADGE_MIN_WIDTH, Math.ceil(textWidth) + 2 * PROVINCE_BADGE_TEXT_PADDING));
      return {
        name: name,
        countLabel: countLabel,
        width: width,
        height: PROVINCE_BADGE_HEIGHT
      };
    },
    getProvinceIcon: function getProvinceIcon(province) {
      if (!province) {
        return null;
      }
      var placement = this.provincePlacements[province.slug] || 0;
      var cacheKey = "".concat(province.slug || 'unknown', "-").concat(province.count || 0, "-").concat(province.shortName || province.name || '', "-").concat(province.countLabel || '', "-").concat(placement);
      if (this.provinceIconCache[cacheKey]) {
        return this.provinceIconCache[cacheKey];
      }
      var _this$getProvinceBadg = this.getProvinceBadge(province),
        name = _this$getProvinceBadg.name,
        countLabel = _this$getProvinceBadg.countLabel,
        width = _this$getProvinceBadg.width,
        height = _this$getProvinceBadg.height;
      var radius = 4;
      var svg = "\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"".concat(width, "\" height=\"").concat(height, "\" viewBox=\"0 0 ").concat(width, " ").concat(height, "\">\n          <defs>\n            <filter id=\"shadow\" x=\"-20%\" y=\"-20%\" width=\"140%\" height=\"160%\">\n              <feDropShadow dx=\"0\" dy=\"4\" stdDeviation=\"6\" flood-opacity=\"0.25\" />\n            </filter>\n          </defs>\n          <rect x=\"0\" y=\"0\" width=\"").concat(width, "\" height=\"").concat(height, "\" rx=\"").concat(radius, "\" ry=\"").concat(radius, "\" fill=\"#EB6909\" stroke=\"rgba(255,255,255,0.2)\" stroke-width=\"1\" filter=\"url(#shadow)\"></rect>\n          <text x=\"").concat(width / 2, "\" y=\"17\" font-size=\"").concat(PROVINCE_BADGE_NAME_FONT_SIZE, "\" font-weight=\"700\" fill=\"#ffffff\" text-anchor=\"middle\" font-family=\"Arial, sans-serif\">").concat(this.escapeSvg(name), "</text>\n          <text x=\"").concat(width / 2, "\" y=\"31\" font-size=\"").concat(PROVINCE_BADGE_COUNT_FONT_SIZE, "\" font-weight=\"700\" fill=\"#ffffff\" text-anchor=\"middle\" font-family=\"Arial, sans-serif\">").concat(this.escapeSvg(countLabel), "</text>\n        </svg>\n      ");
      var icon = {
        url: "data:image/svg+xml;charset=UTF-8,".concat(encodeURIComponent(svg)),
        zIndex: province.zIndex || 5000
      };
      if (this.googleMapsApi) {
        icon.scaledSize = new this.googleMapsApi.Size(width, height);
        // l'anchor è il punto dell'icona che cade sulla coordinata: con dy > 0 il badge sta sotto
        var _PROVINCE_BADGE_POSIT = PROVINCE_BADGE_POSITIONS[placement](width, height),
          dx = _PROVINCE_BADGE_POSIT.dx,
          dy = _PROVINCE_BADGE_POSIT.dy;
        icon.anchor = new this.googleMapsApi.Point(-dx, -dy);
      }
      this.provinceIconCache[cacheKey] = icon;
      return icon;
    },
    // Sceglie dove disegnare ogni badge perché non si coprano: allo zoom corrente, in pixel, i badge
    // vengono messi uno alla volta dal più grande (più cantieri; a parità A→Z) e ognuno prende la
    // prima posizione di PROVINCE_BADGE_POSITIONS che sta tutta dentro la mappa e non tocca quelli
    // già messi. Se non c'è, quella dentro la mappa che si sovrappone meno.
    layoutProvinceBadges: function layoutProvinceBadges() {
      var _this8 = this;
      var maps = this.googleMapsApi;
      if (!this.map || !maps) return;
      var projection = this.map.getProjection();
      var center = this.map.getCenter();
      var zoom = this.map.getZoom();
      var div = this.map.getDiv();
      if (!projection || !center || !Number.isFinite(zoom) || !div) return;
      var scale = Math.pow(2, zoom);
      var centerPoint = projection.fromLatLngToPoint(center);
      var view = {
        left: centerPoint.x * scale - div.offsetWidth / 2,
        top: centerPoint.y * scale - div.offsetHeight / 2
      };
      view.right = view.left + div.offsetWidth;
      view.bottom = view.top + div.offsetHeight;
      var provinces = (this.provinceMarkers || []).filter(function (province) {
        return province && province.slug && Number.isFinite(province.latitude) && Number.isFinite(province.longitude);
      }).sort(function (a, b) {
        return (b.count || 0) - (a.count || 0) || (a.name || '').localeCompare(b.name || '', 'it');
      });
      var placed = [];
      var placements = {};
      provinces.forEach(function (province) {
        var _this8$getProvinceBad = _this8.getProvinceBadge(province),
          width = _this8$getProvinceBad.width,
          height = _this8$getProvinceBad.height;
        var point = projection.fromLatLngToPoint(new maps.LatLng(province.latitude, province.longitude));
        var x = point.x * scale;
        var y = point.y * scale;
        var best = null;
        PROVINCE_BADGE_POSITIONS.forEach(function (position, index) {
          var _position = position(width, height),
            dx = _position.dx,
            dy = _position.dy;
          var rect = {
            left: x + dx,
            top: y + dy,
            right: x + dx + width,
            bottom: y + dy + height
          };
          var outside = rect.left < view.left || rect.top < view.top || rect.right > view.right || rect.bottom > view.bottom;
          var overlap = placed.reduce(function (sum, other) {
            return sum + overlapArea(rect, other);
          }, 0);
          if (!best || (outside === best.outside ? overlap < best.overlap : !outside)) {
            best = {
              index: index,
              rect: rect,
              outside: outside,
              overlap: overlap
            };
          }
        });
        placed.push(best.rect);
        placements[province.slug] = best.index;
      });
      var current = this.provincePlacements;
      var changed = Object.keys(placements).length !== Object.keys(current).length || Object.keys(placements).some(function (slug) {
        return placements[slug] !== current[slug];
      });
      if (changed) {
        this.provincePlacements = placements;
      }
    },
    escapeSvg: function escapeSvg(value) {
      return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },
    openConstruction: function openConstruction(construction) {
      construction.$incrementPopupVisits();
      window.open(construction.url + '?prevent_increment=1', '_blank');
    }
  },
  mounted: function mounted() {
    var _this9 = this;
    this.$refs.myMap.$mapPromise.then(function (map) {
      _this9.map = map;
      _this9.map.addListener('bounds_changed', debounce(_this9.updateBounds, 300));
      if (typeof window !== 'undefined' && window.google && window.google.maps) {
        _this9.googleMapsApi = window.google.maps;
        _this9.provinceIconCache = {};
        // le posizioni dei badge dipendono da zoom e dimensione della mappa: si ricalcolano a
        // ogni cambio di zoom e a mappa ferma (anche dopo un resize)
        _this9.map.addListener('zoom_changed', function () {
          return _this9.layoutProvinceBadges();
        });
        _this9.map.addListener('idle', function () {
          return _this9.layoutProvinceBadges();
        });
        _this9.layoutProvinceBadges();
      }
      // The map can be initialized while its container is still unmeasured
      // (SSR hydration): without a 'resize' trigger it stays blank (grey,
      // no tiles/markers) even though zoom and center are valid. The exact
      // moment hydration settles varies, so re-trigger a few times: it is a
      // visual no-op when the map is already rendered correctly.
      _this9.resizeTimers = [0, 400, 1200, 3000, 6000, 10000].map(function (delay) {
        return setTimeout(function () {
          return _this9.triggerMapResize();
        }, delay);
      });
      // 'idle' also fires after each resize we trigger: cap the count to
      // cover late repaint wipes without looping forever
      _this9.idleResizeCount = 0;
      _this9.map.addListener('idle', debounce(function () {
        if (_this9.idleResizeCount < 5) {
          _this9.idleResizeCount += 1;
          _this9.triggerMapResize();
        }
      }, 300));
      // #19pc — ricarica automatica: 'user-move-end' MOVE_END_DEBOUNCE ms dopo
      // che la mappa si è fermata, e solo se l'ha mossa l'utente.
      _this9.lastUserGestureAt = 0;
      _this9.emitMoveEnd = debounce(_this9.notifyMoveEnd, MOVE_END_DEBOUNCE);
      _this9.map.addListener('idle', _this9.emitMoveEnd);
      // 'drag' arriva in continuazione durante il trascinamento: tiene fresca
      // la finestra del gesto anche su trascinamenti lunghi
      _this9.map.addListener('drag', _this9.markUserGesture);
      USER_GESTURE_EVENTS.forEach(function (name) {
        _this9.$el.addEventListener(name, _this9.markUserGesture, {
          capture: true,
          passive: true
        });
      });
      if (typeof ResizeObserver !== 'undefined') {
        _this9.resizeObserver = new ResizeObserver(debounce(_this9.triggerMapResize, 200));
        _this9.resizeObserver.observe(_this9.$el);
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    var _this10 = this;
    if (this.resizeTimers) {
      this.resizeTimers.forEach(function (timer) {
        return clearTimeout(timer);
      });
      this.resizeTimers = null;
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    // #19pc
    if (this.emitMoveEnd) {
      this.emitMoveEnd.cancel();
      this.emitMoveEnd = null;
    }
    if (this.$el && this.$el.removeEventListener) {
      USER_GESTURE_EVENTS.forEach(function (name) {
        _this10.$el.removeEventListener(name, _this10.markUserGesture, {
          capture: true
        });
      });
    }
    this.googleMapsApi = null;
    this.provinceIconCache = {};
  }
};